module.exports = __webpack_public_path__ + "media/images/sp/top/keyword_inomemado-3aca65ea15917ab7e81f28fbfe08fa49.webp";